import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  text: string;
}
const TestimonialCard = ({
  name,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 md:p-6 rounded-xl border border-white/5 flex flex-col h-full hover:border-brand-accent/50 transition-all duration-300 shadow-lg" data-id="element-237">
    <div className="flex items-center mb-3" data-id="element-238">
      <div className="w-9 h-9 md:w-11 md:h-11 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-base md:text-lg mr-3 shrink-0" data-id="element-239">
        {name.charAt(0)}
      </div>
      <div data-id="element-240">
        <p className="font-black text-white text-sm md:text-base leading-tight mb-0.5" data-id="element-241">
          {name}
        </p>
        <div className="flex text-brand-accent" data-id="element-242">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-current" data-id="element-243" />)}
        </div>
      </div>
    </div>
    <p className="text-gray-300 text-xs md:text-sm italic flex-grow leading-relaxed font-medium" data-id="element-244">
      “{text}”
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Federico Gómez',
    text: 'Con estos diseños empecé a ofrecer trabajos mucho más modernos y los clientes lo notan enseguida. Las puertas y pérgolas premium llaman muchísimo más la atención que los trabajos comunes.'
  }, {
    name: 'Matías Roldán',
    text: 'Lo mejor es que son diseños modernos de verdad, no planos viejos sacados de internet. Ya usé varias ideas para trabajos reales y quedaron espectaculares.'
  }, {
    name: 'Javier Benítez',
    text: 'Me ahorró muchísimo tiempo porque ya tengo diseños modernos listos para mostrarle a los clientes. La oferta completa trae una locura de contenido.'
  }, {
    name: 'Carlos Mendoza',
    text: 'Soy de Chile y acá los clientes piden mucho estilo industrial. Este pack me salvó la vida en el taller, los portones levadizos y las escaleras son un éxito total.'
  }, {
    name: 'Roberto Sánchez',
    text: 'Excelente inversión para el taller. Las medidas vienen perfectas y los diseños de pérgolas se venden solos. Pude subir mis precios porque ahora entrego calidad premium.'
  }];
  return <section className="py-8 md:py-14 px-3 bg-brand-dark" data-id="element-245">
      <div className="max-w-5xl mx-auto" data-id="element-246">
        <h2 className="text-xl md:text-4xl font-black text-center mb-7 text-white uppercase tracking-tight leading-tight" data-id="element-247">
          💬 LO QUE DICEN QUIENES YA USAN ESTOS PLANOS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-248">
          {testimonials.map((t, i) => <div key={i} className={i === 3 ? 'md:col-span-2 lg:col-span-1' : i === 4 ? 'md:col-span-2 lg:col-span-2' : ''} data-id="element-249">
              <TestimonialCard {...t} data-id="element-250" />
            </div>)}
        </div>
      </div>
    </section>;
}